import 'angular';

import { BookingDiaryCtrl }                   from './booking-diary';
import { BookingDiaryDayComponent }           from './booking-diary.day.component.ajs';
import { BookingDiaryDayCtrl }                from './booking-diary.day.ajs';
import { BookingDiaryEventComponent }         from './booking-diary.event.component.ajs';
import { BookingDiaryEventCtrl }              from './booking-diary.event.ajs';
import { BookingDiaryService }                from './booking-diary.services';
import { BookingDiaryShopComponent }          from './booking-diary.shop.component.ajs';
import { BookingDiaryShopCtrl }               from './booking-diary.shop.ajs';
import { BookingDiarySimplifiedCtrl }         from './booking-diary.simplified';
import { BookingDiaryUnassignedJobComponent } from './booking-diary.unassigned-job.component.ajs';
import { BookingDiaryUnassignedJobCtrl }      from './booking-diary.unassigned-job.ajs.ts';
import { BookingDiaryWeekEventComponent }     from './booking-diary.week-event.component.ajs';
import { BookingDiaryWeekEventCtrl }          from './booking-diary.week-event.ajs';
import { BookingStates }                      from './booking-diary.states.ajs';
import { DailyBookingChartCtrl }              from './booking-diary.daily-booking-chart';

angular.module('workshop.booking', [])
  .component('worDay', BookingDiaryDayComponent)
  .component('worEvent', BookingDiaryEventComponent)
  .component('worShop', BookingDiaryShopComponent)
  .component('worUnassignedJob', BookingDiaryUnassignedJobComponent)
  .component('worWeek', BookingDiaryWeekEventComponent)
  .config(BookingStates)
  .controller('BookingDiaryCtrl', BookingDiaryCtrl)
  .controller('BookingDiaryDayCtrl', BookingDiaryDayCtrl)
  .controller('BookingDiaryEventCtrl', BookingDiaryEventCtrl)
  .controller('BookingDiaryShopCtrl', BookingDiaryShopCtrl)
  .controller('BookingDiarySimplifiedCtrl', BookingDiarySimplifiedCtrl)
  .controller('BookingDiaryUnassignedJobCtrl', BookingDiaryUnassignedJobCtrl)
  .controller('BookingDiaryWeekEventCtrl', BookingDiaryWeekEventCtrl)
  .controller('dailyBookingChartCtrl', DailyBookingChartCtrl)
  .factory('BookingDiary', BookingDiaryService);